module.exports = __webpack_public_path__ + "img/shiming.9a5bcfa6.png";